/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import {refreshCheckoutPage} from './common';

$(document).ready(() => {
  prestashop.on('updateCart', (event) => {
    if (event && event.reason && typeof event.reason.cart !== 'undefined') {
      prestashop.cart = event.reason.cart;
    }

    if (event.reason.linkAction !== undefined
      && event.reason.linkAction === 'delete-from-cart'
      && typeof loadCart === 'function') {
      return;
    }

    const getCartViewUrl = $('.js-cart').data('refresh-url');

        if (!getCartViewUrl) {
            return;
        }

        let requestData = {};
        let {idProduct} = event.reason;
        let rightCartProd = $('#right-side-cart .articles');

        if (typeof idProduct === 'undefined' && event.idProduct) {
            idProduct = event.idProduct;
        }

        if (event && event.reason) {
            requestData = {
                id_product_attribute: event.reason.idProductAttribute,
                id_product: event.reason.idProduct,
            };
            if ((typeof (event.reason) !== 'undefined' && typeof (event.reason.errors) !== 'undefined' && event.reason.errors) ||
                (typeof (event.resp) !== 'undefined' && typeof (event.resp.errors) !== 'undefined' && event.resp.errors)) {
                let errorText = '';

                if (typeof (event.reason) !== 'undefined' && typeof (event.reason.errors) !== 'undefined') {
                    for (let i = 0; i < event.reason.errors.length; i++) {
                        if (i !== 'indexOf') {
                            errorText += `${event.reason.errors[i]}<br/>`;
                        }
                    }
                    if (event.reason.product_id_error) {
                        const productAvailability = $(`.product-miniature[data-id-product=${event.reason.product_id_error}]`).find('.product-availability');
                        productAvailability.removeClass('loading');
                    }
                }
                if (typeof (event.resp) !== 'undefined' && typeof (event.resp.errors) !== 'undefined') {
                    if (typeof event.resp.errors === 'string') {
                        errorText = event.resp.errors;
                    } else {
                        for (let i = 0; i < event.resp.errors.length; i++) {
                            if (i !== 'indexOf') {
                                errorText += `${event.resp.errors[i]}<br/>`;
                            }
                        }
                        if (event.resp.product_id_error) {
                            const productAvailability = $(`.product-miniature[data-id-product=${event.resp.product_id_error}]`).find('.product-availability');
                            productAvailability.removeClass('loading');
                        }
                    }
                }

                if (errorText) {
                    $.gritter.add({
                        text: "<div class='favorite-remove'>" +
                            errorText +
                            "<div class='close'><svg><use xlink:href='#icon-x-white'/></svg></div>" +
                            "</div>",
                        class_name: 'gritter-warning',
                        sticky: false,
                        time: '6000',
                    });
                }
            } else {
              /*if (typeof (hasRightSideCart) !== 'undefined' && hasRightSideCart) {
                  if (showUpdateCartNotification && !hideUpdateCartNotification) {
                      $.gritter.add({
                          text: product_qty_update_success,
                          class_name: 'gritter-success',
                          sticky: false,
                          time: '4000',
                      });
                  }
              } else {
                  $.gritter.add({
                      text: product_qty_update_success,
                      class_name: 'gritter-success',
                      sticky: false,
                      time: '3000',
                  });
              }
*/
              const productAvailability = $(`.product-miniature[data-id-product=${event.reason.idProduct}]`).find('.product-availability');
              productAvailability.removeClass('loading').addClass('cart-updated').delay(2000).queue(function () {
                  $(this).removeClass('cart-updated');
                  $(this).dequeue();
              });
          }
          if (typeof (event.reason.linkAction) !== 'undefined' && (event.reason.linkAction === 'add-to-cart' || event.reason.linkAction === 'update-cart') && typeof loadCart === 'function') {
              var reloadCart = true;
          }

          if (typeof (event.reason.useSavedPrices) !== 'undefined' && event.reason.useSavedPrices) {
              requestData.useSavedPrices = true;
          }

          if (typeof updateFreeProduct === 'function' && typeof event.reason.noFreeProductUpdate === 'undefined') {
              updateFreeProduct(idProduct);
          }
          if (typeof updatePanashierFreeProducts === 'function') {
              updatePanashierFreeProducts();
          }
      }
      $(document).on('click', '.gritter-warning .close', function() {
          $(this).closest('.gritter-warning').remove();
      });
      function getPageOrder(url) {
          return $.ajax({
              url: url,
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          })
              .done(function (data) {
                  const parsedHTML = $('<div>').html(data);
                  const cartBody = parsedHTML.find('#opc_cart_body');
                  cartBody.find('script').remove();
                  cartBody.find('#conditions-to-approve').remove();
                  cartBody.find('#payment-confirmation').remove();
                  const cartBodyContent = cartBody.html();
                  $(prestashop.selectors.checkout.summarySelector).replaceWith(
                      cartBodyContent,
                  );
              })
              .fail(function (jqXHR, textStatus, errorThrown) {
                  console.error('Failed to fetch page order:', textStatus, errorThrown);
              });
      }

      let opcCart = $('#opc_main');

      if (opcCart.length && !opcCart.find(".loading-opc")) {
          opcCart.append('<div class="loading-opc"></div>');
      }

      $.post(getCartViewUrl, requestData)
          .then((resp) => {
              $(prestashop.selectors.cart.detailedTotals).replaceWith(
                resp.cart_detailed_totals,
              );

              if ($('body').hasClass('page-cart')) {
                $(prestashop.selectors.cart.overview).replaceWith(
                  resp.cart_detailed,
                );
              }

              $('.crd-cart-summary span').text(resp.products)

               /* $(prestashop.selectors.cart.summaryItemsSubtotal).replaceWith(
                    resp.cart_summary_items_subtotal,
                );
                $(prestashop.selectors.cart.summarySubTotalsContainer).replaceWith(
                    resp.cart_summary_subtotals_container,
                );

                $(prestashop.selectors.cart.summaryTotals).replaceWith(
                    resp.cart_summary_totals,
                );

                $(prestashop.selectors.cart.voucher).replaceWith(resp.cart_voucher);
                $(prestashop.selectors.cart.summaryTop).replaceWith(
                    resp.cart_summary_top,
                );*/

                if (resp.cart_category != false) {
                    $('.category-top').html(resp.cart_category);
                }
                $('.category-bottom').html(resp.checkout_link);
                $('#right-side-cart .articles').html(resp.right_cart_articles);
                $('#right-side-cart .right-cart-summary').html(resp.right_cart_totals);
                $('#_desktop_cart').replaceWith(resp.block_cart);

                if (resp.products > 0 && rightCartProd.hasClass('no-articles')) {
                    rightCartProd.removeClass('no-articles');
                    rightCartProd.addClass('has-articles');
                } else if (rightCartProd.hasClass('has-articles')) {
                    rightCartProd.removeClass('has-articles');
                    rightCartProd.addClass('no-articles');
                }

                $(prestashop.selectors.cart.productCustomizationId).val(0);

                $(prestashop.selectors.cart.lineProductQuantity).each(
                    (index, input) => {
                        const $input = $(input);
                        $input.attr('value', $input.val());
                    },
                );

                if (typeof showInfoIconOnProdList !== 'undefined') {
                    showInfoIconOnProdList();
                }

                if (typeof showInfoIconOnProdPage !== 'undefined') {
                    showInfoIconOnProdPage(resp.assort_next_prod);
                }

                if (typeof showInfoIconOnFavorites !== 'undefined' && ($('body').attr('id') == 'module-crd_favorites-productlist' || $('body').attr('id') == 'module-crd_history-historyproducts')) {
                    showInfoIconOnFavorites(resp.assort_next_prod);
                }

                if (reloadCart == true) {
                    loadCart(false, false);
                }
                // todo
                if ($('#right-side-cart').length && ($('#right-side-cart').outerHeight() + 40 > $('body').height())) {
                    $('.right-cart-summary').css('overflowY', 'auto');
                } else {
                    $('.right-cart-summary').css('overflowY', 'auto');
                }
                if (typeof page_lang_code === 'undefined') {
                    var page_lang_code = prestashop.language.iso_code;
                }
                if (resp.show_box_alert && resp.box_qty !== undefined && typeof alertBoxQty === 'function') {
                    alertBoxQty(resp.show_box_alert);
                }
                if (resp.show_personalzied_prod_alert && typeof alertPersonalizedProdAdded === "function") {
                    alertPersonalizedProdAdded(resp.show_personalzied_prod_alert);
                }
                if ($(prestashop.selectors.checkout.cartPaymentStepRefresh).length) {
                    // we get the refresh flag : on payment step we need to refresh page to be sure
                    // amount is correctly updated on payment modules
                    refreshCheckoutPage();
                }

                prestashop.emit('updatedCart', {eventType: 'updateCart', resp});

                let opcCart = $('#opc_main');

                if (opcCart.length) {
                    opcCart.find(".loading-opc").remove();
                }
            })
            .fail((resp) => {
                prestashop.emit('handleError', {eventType: 'updateCart', resp});
            });
    });

    const $body = $('body');

    $body.on('click', '[data-button-action="add-to-cart"]', (event) => {
        event.preventDefault();

        // disabled place order while cart is being updated
        $('#supercheckout_confirm_order').addClass('disabled');

        const $form = $(event.currentTarget.form);
        const $qtyInput = $form.find('.qty-input');

        if ($qtyInput.val() == 0) {
            $qtyInput.val(1);
        }
        const query = `${$form.serialize()}&add=1&action=update`;
        const actionURL = $form.attr('action');
        const addToCartButton = $(event.currentTarget);

        addToCartButton.prop('disabled', true);

        const isQuantityInputValid = ($input) => {
            let validInput = true;

            $input.each((index, input) => {
                const $currentInput = $(input);
                const minimalValue = parseInt($currentInput.attr('min'), 10);

                if (minimalValue && $currentInput.val() < minimalValue) {
                    onInvalidQuantity($currentInput);
                    validInput = false;
                }
            });

            return validInput;
        };

        let onInvalidQuantity = ($input) => {
            $input
                .parents(prestashop.selectors.product.addToCart)
                .first()
                .find(prestashop.selectors.product.minimalQuantity)
                .addClass('error');
            $input
                .parent()
                .find('label')
                .addClass('error');
        };

        const $quantityInput = $form.find('input[min]');

        if (!isQuantityInputValid($quantityInput)) {
            onInvalidQuantity($quantityInput);

            return;
        }

        $.post(actionURL, query, null, 'json')
            .then((resp) => {
                if (typeof (resp.hasError) !== 'undefined' && resp.hasError === true) {
                    prestashop.emit('updateCart', {
                        reason: {
                            errors: resp.errors,
                        },
                    });
                } else {
                  $('.gritter-item-wrapper').remove();
                  $.gritter.add({
                    text: product_qty_update_success,
                    class_name: 'gritter-success',
                    sticky: false,
                    time: '4000',
                  });
                    prestashop.emit('updateCart', {
                        reason: {
                            idProduct: resp.id_product,
                            idProductAttribute: resp.id_product_attribute,
                            idCustomization: resp.id_customization,
                            linkAction: 'add-to-cart',
                            cart: resp.cart,
                        },
                        resp,
                    });
                }
            })
            .fail((resp) => {
                prestashop.emit('handleError', {
                    eventType: 'addProductToCart',
                    resp,
                });
            })
            .always(() => {
                setTimeout(() => {
                    addToCartButton.prop('disabled', false);
                }, 1000);
            });
    });

    $body.on('submit', '[data-link-action="add-voucher"]', (event) => {
        event.preventDefault();

        const $addVoucherForm = $(event.currentTarget);
        const getCartViewUrl = $addVoucherForm.attr('action');

        if ($addVoucherForm.find('[name=action]').length === 0) {
            $addVoucherForm.append(
                $('<input>', {type: 'hidden', name: 'ajax', value: 1}),
            );
        }
        if ($addVoucherForm.find('[name=action]').length === 0) {
            $addVoucherForm.append(
                $('<input>', {type: 'hidden', name: 'action', value: 'update'}),
            );
        }

        $.post(getCartViewUrl, $addVoucherForm.serialize(), null, 'json')
            .then((resp) => {
                if (resp.hasError) {
                    $('.js-error')
                        .show()
                        .find('.js-error-text')
                        .text(resp.errors[0]);

                    return;
                }

                // Refresh cart preview
                prestashop.emit('updateCart', {
                    reason: event.target.dataset,
                    resp,
                });
            })
            .fail((resp) => {
                prestashop.emit('handleError', {eventType: 'updateCart', resp});
            });
    });
});
